import { checkBaseField } from "src/generator/utils/getCheckListProgress";

/**
 * Filters and returns the changed checklists based on specific conditions.
 *
 * @param checklists - An array of checklists to evaluate.
 * @param dataPropertyPresent - (Optional) A flag indicating whether the `data` property is present in the checklist. Defaults to `false`.
 * @param summary - (Optional) A flag indicating whether the checklist is part of a summary. Defaults to `false`.
 * @returns An array of filtered and updated checklists.
 */
export const getChangedChecklists = (
  checklists: any[],
  dataPropertyPresent?: boolean,
) => {
  /**
   * Checks if at least one item in the list or its sub-items is checked.
   *
   * @param list - The list of items to evaluate.
   * @returns `true` if at least one item is checked, otherwise `false`.
   */
  const someCheck = (list: any) =>
    list && list.some
      ? list.some((item: any) =>
          item.text
            ? checkBaseField(item)
            : item.items.some((item: any) => checkBaseField(item)),
        )
      : null;

  let parsedChecklists = [];
  if (dataPropertyPresent)
    parsedChecklists = checklists.filter(el => someCheck(el.data.list));
  else parsedChecklists = checklists.filter(el => someCheck(el.list));

  return parsedChecklists.map(checklist => {
    let list = dataPropertyPresent ? checklist.data.list : checklist.list;
    list = list.filter((el: any) => (el.items ? someCheck(el.items) : true));
    if (dataPropertyPresent)
      return {
        ...checklist,
        data: {
          ...checklist.data,
          list,
        },
      };

    return {
      ...checklist,
      list,
    };
  });
};
